import { useUserStore } from "../../../../common/store/src/user";
import { redirect } from "react-router-dom";

export async function AuthLoader({ request }: { request: Request }) {
  if (useUserStore.getState().loginStatus) {
    return null;
  }
  try {
    const link = new URL(request.url);
    return redirect(
      "/login?from=" + encodeURIComponent(link.href.replace(link.origin, ""))
    );
  } catch (e: any) {
    console.error(e);
  }
  return redirect(
    "/login?from=" + encodeURIComponent(location.pathname + location.search)
  );
}
